package io.horion.auth.presentation.ui.styles

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.BoxSizing
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.dvh
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.base
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.s
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.FaSpinner
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorPalette
import io.horion.auth.presentation.ui.theme.AuthColors
import org.jetbrains.compose.web.css.*

// Plus de "by" : affectation directe
val SpinAnimation = Keyframes {
    from { Modifier.rotate(0.deg) }
    to { Modifier.rotate(360.deg) }
}

val SpinStyle = CssStyle.base {
    Modifier.animation(
        SpinAnimation.toAnimation(
            duration = 1.s,
            timingFunction = AnimationTimingFunction.Linear,
            iterationCount = AnimationIterationCount.Infinite
        )
    )
}

// ── STYLES RESPONSIVES POUR LE CHARGEMENT ──────────────────────────────────────────

val LoadingContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .minHeight(100.dvh) // 🎯 dvh (Dynamic Viewport Height) pour s'adapter parfaitement aux barres de navigateur mobile
            .padding(16.px)
            .boxSizing(BoxSizing.BorderBox)
    }
    Breakpoint.MD {
        Modifier.padding(32.px)
    }
}

val LoadingSpinnerStyle = CssStyle {
    base {
        Modifier.fontSize(32.px) // 🎯 Taille réduite pour petits écrans mobiles
    }
    Breakpoint.SM {
        Modifier.fontSize(40.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(56.px)
    }
}

val LoadingTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px) // 🎯 Taille adaptée mobile
            .textAlign(TextAlign.Center)
    }
    Breakpoint.SM {
        Modifier.fontSize(18.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(22.px)
    }
}

val LoadingContentGapStyle = CssStyle {
    base {
        Modifier.gap(12.px)
    }
    Breakpoint.SM {
        Modifier.gap(16.px)
    }
    Breakpoint.MD {
        Modifier.gap(20.px)
    }
}

// ── COMPOSANT UI RESPONSIVE ──────────────────────────────────────────────────

@Composable
fun LoadingScreen(colors: AuthColors) {
    Box(
        modifier = LoadingContainerStyle.toModifier()
            .background(colors.background),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center,
            modifier = LoadingContentGapStyle.toModifier()
                .fillMaxWidth() // 🎯 S'assure que le contenu reste bien centré sur tout écran
        ) {
            FaSpinner(
                modifier = SpinStyle.toModifier()
                    .then(LoadingSpinnerStyle.toModifier())
                    .color(colors.primary)
            )

            SpanText(
                "Chargement en cours...",
                modifier = LoadingTextStyle.toModifier()
                    .color(colors.primary)
                    .fontWeight(FontWeight.Bold)
            )
        }
    }
}